import React from 'react';

import styles from './XFrame.module.scss';
//import {DateTime} from "luxon";
import {} from "../../Utilities/Utilities";
import { XComponent } from '../commons/XComponent';
import { IComponentState } from '../commons/IComponentState';
import { IComponentProps } from '../commons/IComponentProps';


export interface IFrameProps extends IComponentProps {
    children? : React.ReactNode;
}

export interface IFrameState extends IComponentState {
}

export class XFrame extends XComponent<HTMLDivElement, IFrameProps, IFrameState> {
    public constructor(props: any) {
        super(props);
    }
    render(): React.ReactNode {
        return (
            <div className={styles.XFrame}>         
                {this.props.children}
            </div>
        );
    }
}